import React from 'react';
import { Link } from 'react-router-dom';
import { MdMovie, MdEmail } from 'react-icons/md';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="site-footer">
      <div className="footer-content">
        <div className="footer-section brand">
          <div className="footer-logo">
            <MdMovie className="logo-icon" />
            <span>TollyHype</span>
          </div>
          <p className="footer-desc">
            Your ultimate destination for tracking the hype around upcoming Telugu and Tamil movie releases. Vote, chat, and climb the leaderboard!
          </p>
        </div>

        <div className="footer-section links">
          <h3>Quick Links</h3>
          <ul>
            <li><Link to="/">Home</Link></li>
            <li><Link to="/charts">Top Charts</Link></li>
            <li><Link to="/leaderboard">Leaderboard</Link></li>
            <li><Link to="/chat">Community Chat</Link></li>
          </ul>
        </div>

        <div className="footer-section links">
          <h3>Legal & Support</h3>
          <ul>
            <li><Link to="/privacy">Privacy Policy</Link></li>
            <li><Link to="/terms">Terms & Conditions</Link></li>
            <li><Link to="/contact">Contact Us</Link></li>
          </ul>
        </div>

        <div className="footer-section contact">
          <h3>Get in Touch</h3>
          <p><MdEmail className="footer-icon" /> support@tollyhype.com</p>
          <p className="footer-location">Hyderabad, India</p>
        </div>
      </div>
      
      <div className="footer-bottom">
        <p>&copy; {currentYear} TollyHype. All rights reserved.</p>
      </div>
    </footer>
  );
}

